import { render, staticRenderFns } from "./atendimentos.vue?vue&type=template&id=00d1f852&scoped=true"
import script from "./atendimentos.vue?vue&type=script&lang=js"
export * from "./atendimentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d1f852",
  null
  
)

export default component.exports